module.exports = __webpack_public_path__ + "static/img/4.62a93e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/eng/4.png
// module id = Iy88
// module chunks = 0